<template>
   <v-content>
    <v-flex class="spacetop">
      <v-card>
       
          <v-card-text class="notfound">iPhone device, iOS 12 version or greater!</v-card-text>
      </v-card >
       
    </v-flex>
  </v-content>


</template>
<style scoped>
  .spacetop{
    padding-top: 143px;
  }
  .swleft{
    float: right;
    position: relative;
    top: -41px;
    /* width: 269px !important;*/
   }
   .cusfont17px{
    font-size: 17px;
   }
   .btn_floading{
          position: fixed;
          bottom: 20px;
          right: 20px;
    /* padding: 25px; */
    }
    .v-btn--floating{
      border-radius: 50% !important;  
    }
</style>
<script>
 // 
  import { mapState } from 'vuex';
  import axios from 'axios';
  import TheHeader from "@/components/TheHeader";
  import TheFooter from "@/components/TheFooter";
  import CampaignRequest from '@/components/CampaignRequest';
  import FlightRequest from '@/components/FlightRequest';
  //import HelloWorld from '../components/HelloWorld'
  import { loginService } from '@/components/_service/Users.js';
  import { vapidKey } from '@/components/_service/Config.js';
  import { notificationservice} from '@/components/_service/Notification.js';
  const API_URL = process.env.API_URL || 'https://mobile.innity.com.my/apipost'
  import ServiceWorkerStorage from 'serviceworker-storage';
  const storage = new ServiceWorkerStorage('sw:storage', 1);
 

  export default {

    components: {
      TheHeader,
      TheFooter,
      CampaignRequest,
      FlightRequest,
     // HelloWorld
    },
   data () {
      return {
          dialog: false,
          notificationsSupported: false,

          notificationsEnabled: false,
          buttonDisabled: false,
          serviceWorkerRegistation: null,
          subscription: null,
        //  vapidPublicKey:"",
          arrayUser:[],
          message:"",
          flightcount:0,
          userId:loginService.getSaleId(),
          camcount:0,
          pushSubscription:null,
          fstCheck: true,
          userexit: 0,

        notifications: false,
        sound: true,
        widgets: false
          //isSalePrivilege:false
        

      }
    },
    
  computed:{
      // isSalePrivilege(){
      //  return this.$store.state.isSalePrivilege.approve_flight_request
      // }
  },

   methods: {
   
         toggle(value, event) {
     //   if (this.notificationsSupported) {
             console.log(`update1 ${value} ${event}`);
            this.buttonDisabled = true
          if (event && !this.notificationsEnabled){
                
            console.log('notificationsEnabled' +this.notificationsEnabled)

            Notification.requestPermission()
                    .then(result => {
                        // if granted, create new subscription
                        if (result === 'granted') {
                            notificationservice.createSubscription(this.subscription)
                            .then(sub => {
                             //   console.log('subscription created on the client', sub);
                                this.subscription = sub
                             //   console.log(this.createSubscription())
                                // get new (or existing user) from backend
                              
                                console.log('user created on the server', this.userId);
                                // store new subscription on the server
                                return axios.post(`${API_URL}/push.php`, {
                                    subscription: this.subscription,
                                    userId: this.userId,
                                    isSaleAccess:0,
                                    flightcount: this.flightcount,
                                    camcount : this.camcount,
                                    axn:"subscribe",
                                })
                            })
                            .then((result) => {
                                notificationservice.showNotification()
                               // console.log(this.subscription.endpoint)
                                storage.setItem('subscription',this.subscription.endpoint )
                                this.buttonDisabled = false
                                value = this.notificationsEnabled = true
                                this.lblNotification ="On"
                                this.fstCheck= false
                            })
                        } else {
                            //console.log('User did not granted permission')
                        }
                    })
          }else{

              console.log('Disable subscription' +  this.subscription);
             //  value = this.notificationsEnabled = false
              // value = this.notificationsEnabled = event
              // this.buttonDisabled = event
                 

            if (this.subscription !== null) {
                  // destroy on the server
                  return axios.post(`${API_URL}/push.php`, {
                      endpoint: this.subscription.endpoint,
                      axn:"unsubscribe",
                      userId: this.userId,
                  })
                  // unsubscribe on the client
                  .then(() => this.subscription.unsubscribe())
                  .then(() => {
                      // update the data
                      this.fstCheck = true
                      storage.removeItem('subscription')
                      value = this.notificationsEnabled = false
                      this.buttonDisabled = false
                     
                      this.subscription = null

                  })
              }

            //  this.lblNotification ="On";
              //value = event
              console.log(`update ${value} ${event}`);
          }
        },
         // getsalePrivilege(){
         //        this.$store.dispatch('checkCampaignAccess')
         //         .then(() => 

         //            this.loading =false
                 
         //          )
         //         .catch(err => {
         //            console.log(err )
                   
         //         })
                
         //      // loginService.getAIOAcess().then((data)=>{
         //      //   this.isSalePrivilege = data.approve_flight_request;
                
                    
         //      // });
         //    },
       // autoToggleSubscription(){
       //   console.log(this.notificationsEnabled)
       //    if (!this.notificationsEnabled) {
       //              // Ask permission and when granted, create new subscription
       //              Notification.requestPermission()
       //              .then(result => {
       //                  // if granted, create new subscription
       //                  if (result === 'granted') {
       //                     notificationservice.createSubscription( this.subscription)
       //                      .then(sub => {
       //                         console.log('auto subscription created on the client', sub);
       //                          this.subscription = sub
       //                           this.fstCheck= true
       //                       //   console.log(this.createSubscription())
       //                          // get new (or existing user) from backend
                              
       //                         // console.log('user created on the server', this.userId);
       //                          // store new subscription on the server
       //                          return axios.post(`${API_URL}/push.php`, {
       //                              subscription: this.subscription,
       //                              userId: this.userId,
       //                              isSaleAccess:this.$store.state.isSalePrivilege.approve_flight_request,
       //                              subscriber:'login',
       //                              flightcount: this.flightcount,
       //                              camcount : this.camcount,
       //                              axn:"subscribe",
       //                          })
       //                      })
       //                      .then((result) => {
       //                          notificationservice.showNotification()
       //                         // console.log(this.subscription.endpoint)
       //                       //   storage.setItem('subscription',this.subscription.endpoint )
       //                          this.buttonDisabled = false
       //                          this.notificationsEnabled = true
       //                          this.fstCheck= false
       //                      })
       //                  } else {
       //                      //console.log('User did not granted permission')
       //                  }
       //              })
       //    }
       // },

       // toggleSubscription() {
       //   // console.log(this.notificationsEnabled)
       //      if (this.notificationsSupported) {
       //          this.buttonDisabled = true
       //          // Find out if we need to create a subscription or delete it
       //          if (!this.notificationsEnabled) {
       //              // Ask permission and when granted, create new subscription
       //              Notification.requestPermission()
       //              .then(result => {
       //                  // if granted, create new subscription
       //                  if (result === 'granted') {
       //                      this.createSubscription()
       //                      .then(sub => {
       //                       //   console.log('subscription created on the client', sub);
       //                          this.subscription = sub
       //                       //   console.log(this.createSubscription())
       //                          // get new (or existing user) from backend
                              
       //                         // console.log('user created on the server', this.userId);
       //                          // store new subscription on the server
       //                          return axios.post(`${API_URL}/push.php`, {
       //                              subscription: this.subscription,
       //                              userId: this.userId,
       //                              isSaleAccess:this.$store.state.isSalePrivilege.approve_flight_request,
       //                              flightcount: this.flightcount,
       //                              camcount : this.camcount,
       //                              axn:"subscribe",
       //                          })
       //                      })
       //                      .then((result) => {
       //                          this.showNotification()
       //                         // console.log(this.subscription.endpoint)
       //                          storage.setItem('subscription',this.subscription.endpoint )
       //                          this.buttonDisabled = false
       //                          this.notificationsEnabled = true
       //                          this.fstCheck= false
       //                      })
       //                  } else {
       //                      //console.log('User did not granted permission')
       //                  }
       //              })
       //          } else {
       //              // Destroy subscription
       //              console.log('Disable subscription');
       //              if (this.subscription !== null) {
       //                  // destroy on the server
       //                  return axios.post(`${API_URL}/push.php`, {
       //                      endpoint: this.subscription.endpoint,
       //                      axn:"unsubscribe",
       //                      userId: this.userId,
       //                  })
       //                  // unsubscribe on the client
       //                  .then(() => this.subscription.unsubscribe())
       //                  .then(() => {
       //                      // update the data
       //                      this.fstCheck = true
       //                      storage.removeItem('subscription')
       //                      this.notificationsEnabled = false
       //                      this.buttonDisabled = false
       //                      this.subscription = null

       //                  })
       //              }
       //          }
       //      }
       //  },
    

        // askPermission() {
        //   return new Promise(function(resolve, reject) {
        //     const permissionResult = Notification.requestPermission(function(result) {
        //      //  console.log('result from permission question', result);

        //        resolve(result);
        //     });

        //     if (permissionResult) {
        //    //   this.showNotification();
        //       permissionResult.then(resolve, reject);
        //     }
        //   })
        //   .then(function(permissionResult) {
        //     if (permissionResult !== 'granted') {
        //        // console.warn('We weren\'t granted permission.')
        //      // throw new Error();
        //     }
        //   });
        // },
        // createSubscription() {
        //     console.log('ask for active service worker registration');
        //   //  console.log(this.serviceWorkerRegistation )
        //     if (this.serviceWorkerRegistation === null) {
           
        //         return navigator.serviceWorker.ready // returns a Promise, the active SW registration
        //         .then(swreg => {
        //           // console.log("createSubscription")
        //          //  console.log(swreg)
        //             this.serviceWorkerRegistation = swreg
                 
        //             return this.subscribe(this.serviceWorkerRegistation)
        //         })
        //     } else {
        //         this.fstCheck= true
        //         return this.subscribe(this.serviceWorkerRegistation)
        //     }
        // },
        // subscribe(swreg) {
        //   //  console.log('create new subscription for this browser on this device');
        //     // create new subscription for this browser on this device
        //     const vapidPublicKey = vapidKey
        //     const convertedVapidPublicKey = this.urlBase64ToUint8Array(vapidPublicKey)
        //     // // return the subscription promise, we chain another then where we can send it to the server
        //     return swreg.pushManager.subscribe({
        //         userVisibleOnly: true,
        //         // This is for security. On the backend, we need to do something with the VAPID_PRIVATE_KEY
        //         // that you can find in .env to make this work in the end
        //         applicationServerKey: convertedVapidPublicKey
        //     })
        // },
        // getSubscription(swreg) {
        //   //  console.log('[getSubscription] ask for available subscription');
        //     return swreg.pushManager.getSubscription()
        // },

        createPushNotification1() {
        
           if(this.subscription){
              // console.log('here');
                const req = new Request(`${API_URL}/send_notification.php`, {
                method: 'POST',
                body: JSON.stringify(
                    { 
                    //    subscription: this.subscription,
                      userId:this.userId,
                      flightcount:this.flightcount,
                      camcount:this.camcount,
                      }
                    )
                });
                const response =  self.fetch(req);

           }else{
              //console.log("[createPushNotification1] null")
           }
            
        },
        getUserNotification(){
           // this.userexit = axios.post(`${API_URL}/push.php`, {
           //          userId: this.userId,
           //          axn:"userexit",
           //      }) 
        },
        // showNotification() {
        //     if ('serviceWorker' in navigator) {
        //        if (Notification.permission === 'granted') {
        //           navigator.serviceWorker.ready // returns a Promise, the active SW registration
        //             .then(swreg => swreg.showNotification('Notifications granted', {
        //                 body: 'You will recieve notification',
        //                 icon: '/img/icons/pwa-192.png',
        //                 badge: '/img/icons/pwa-72.png', 
        //                 vibrate: [300, 200, 300],
        //                 data: {
        //                   url:'https://m.advenueplatform.com'
        //                 },
                        
        //             }))
        //       }
        //     }
        // },
        
        // findSubscription1() {
        //   //  console.log('[findSubscription] get active service worker registration');
        //     return navigator.serviceWorker.ready
        //     .then(registration => {
        //       //  console.log('[findSubscription] active subscription op'+ registration);
        //      //   this.serviceWorkerRegistation = swreg
        //        console.log("sssssssssssssss")
        //         return registration.pushManager.getSubscription();
        //     })
        // },
         
        toggleSubscription1(){
          // const convertedVapidKey = this.urlBase64ToUint8Array(this.vapidPublicKey);
          // const userId = this.userId;
          // const camcount = this.camcount;
          // const flightcount = this.flightcount;
          // const isSaleAccess = this.$store.state.isSalePrivilege.approve_flight_request
          // navigator.serviceWorker.ready
          // .then(function(registration) {
          //  // console.log('[toggleSubscription1] service worker registered');
          //   //subscriptionButton.removeAttribute('disabled');

          //   return registration.pushManager.getSubscription();
          //     }).then(function(subscription) {
          //       if (subscription) {
          //        // console.log('Already subscribed', subscription.endpoint);
          //         navigator.serviceWorker.ready
          //                 .then(function(registration) {
          //                //   console.log("registration" + registration.scope);
          //                   return registration.pushManager.getSubscription();
          //                 }).then(function(subscription) {
          //                   return subscription.unsubscribe()
          //                     .then(function() {
          //                     //  console.log('Unsubscribed', subscription.endpoint);
                              
          //                       return fetch(`${API_URL}/push.php`, {
          //                         method: 'post',
          //                         headers: {
          //                           'Content-type': 'application/json'
          //                         },
          //                         body: JSON.stringify({
          //                           // subscription: subscription,
          //                           endpoint:subscription.endpoint,
          //                           axn:"unsubscribe",
          //                           userId: userId,
          //                         })
          //                       });
          //                     });
          //                 }).then(() => {
          //                     //console.log(storage)
          //                     storage.removeItem('subscription');
                           
          //                 })
          //       } else {
          //         navigator.serviceWorker.ready
          //           .then(function(registration) {

          //            // const response = await fetch('./vapidPublicKey');
          //             //console.log(this.vapidPublicKey)
                   
          //             return registration.pushManager.subscribe({
          //               userVisibleOnly: true,
          //               applicationServerKey: convertedVapidKey
          //             });
          //           }).then(function(subscription) {
          //           //  console.log('Subscribed', subscription.endpoint);
          //             return fetch(`${API_URL}/push.php`, {
          //               method: 'post',
          //               headers: {
          //                 'Content-type': 'application/json'
          //               },
          //               body: JSON.stringify({
          //                 subscription: subscription,
          //                 userId: userId,
          //                 isSaleAccess:isSaleAccess,
          //                 flightcount: flightcount,
          //                 camcount : camcount,
          //                 axn:"subscribe",

          //               })
          //             });
                     
          //           }).then(function(subscription){
          //             //  console.log(subscription)
          //               storage.setItem('subscription', subscription.endpoint);
          //               navigator.serviceWorker.ready
          //                 .then(function(registration) {
          //                 //  console.log("registration :" + registration.scope);
          //                   return registration.pushManager.getSubscription();
          //                 })
          //           })
          //       }
          //     });
        },
         // urlBase64ToUint8Array(base64String) {
         //    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
         //    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

         //    const rawData = window.atob(base64);
         //    const outputArray = new Uint8Array(rawData.length);

         //    for (let i = 0; i < rawData.length; ++i) {
         //      outputArray[i] = rawData.charCodeAt(i);
         //    }
         //    return outputArray;
         //  },
       
    
    
     async  handlePush(newSubscription,flightcount,camcount) {
      
       let  oldSubscription = await storage.getItem('subscription');
        if(newSubscription.endpoint !== this.oldSubscription) {
          storage.setItem('subscription', newSubscription.endpoint);
          const req = new Request(`${API_URL}/push.php`, {
          method: 'POST',
          body: JSON.stringify(
                { 
                  oldSubscription:oldSubscription, 
                  newSubscription: newSubscription,
                  userId:this.userId,
                  flightcount: flightcount,
                  camcount : camcount,
                  isSaleAccess:this.$store.state.isSalePrivilege.approve_flight_request,
                  axn:"refreshpushsubscription",
                }
              )
          });
          const response =  self.fetch(req);
        }

      },
    
  },
  
  created() {
   console.log(this.$store.state.isSalePrivilege.approve_flight_request)
    console.log(this.userexit);
     if ('serviceWorker' in navigator && 'PushManager' in window) {
    
          this.notificationsSupported = true   
         
          let start = Date.now();
          let times = [];
            
            setTimeout(function () { 
               times.push(Date.now() - start);
              if (start + 100 < Date.now()) { 
                    if (this.fstCheck && this.subscription != null) {

                      //console.log("send_notification");
                    //  this.createPushNotification1()
                    }else{
                    //  console.log("dont send_notification")
                    }
            
              }else{
                
                 setTimeout(run); // else re-schedule
              } 

             
            }.bind(this), 1000)
            
        }

              
    },
  updated(){
    //  console.log(this.flightcount)
    //  console.log(this.camcount)
  },

  beforeUpdate(){   
     
    // if (this.subscription){
     
    //   if (this.flightcount > 0 || this.camcount > 0){
    //    // console.log("how many callback actions")
    //      this.handlePush(this.subscription,this.flightcount,this.camcount);
    //   }
    // }
  },

  mounted(){ 
     // this.getUserNotification();
      //////////////////////////////////////
      // ask perimssion notifcation
     
      
      //////////////////////////////////

      //this.vapidPublicKey = 'BF180NMKQyTlFDQNFQjknxnCv01AH50kaOST7mAYw-KB1rN3kipSHP-FGM1H_9237UqxSWaaRGwuZVmBupcEMY4';
      this.dialog = this.$store.state.isLoading
     
      notificationservice.findSubscription1()
            .then(sub => {
              //  console.log(sub +"ssssssss")
                if (sub === null) {
                    //this.autoToggleSubscription();
                  //  console.log('[mounted updated] no active subscription found on the client');
                    this.buttonDisabled = false
                    this.notificationsEnabled = false
                } else {
                   // console.log('[mounted updated] Active subscription found', sub);
                    // retrieve user info from API

                    this.buttonDisabled = false
                    this.notificationsEnabled = true
                    this.subscription = sub

                   // this.handlePush(sub,this.flightcount,this.camcount);
                
                }
      })
     
     //console.log(this.dialog)
    },
    watch: {
      dialog (val) {
        if (!val) return

        setTimeout(() => (this.dialog = false), 4000)
      }
    }
   
  }
</script>